import React from 'react';
import { render } from '@testing-library/react';
import DocumentDropZone from './document_drop_zone';

describe('DocumentDropZone', () => {
    it('renders drop zone', () => {
        const { container } = render(
            <DocumentDropZone onFileSelected={jest.fn()} />
        );
        expect(container.firstChild).toBeTruthy();
    });

    it('renders file input', () => {
        const { container } = render(
            <DocumentDropZone onFileSelected={jest.fn()} />
        );
        const input = container.querySelector('input[type="file"]');
        expect(input).toBeTruthy();
    });
});
